import { FCC } from '@psl/utils/react';
import { createContext, memo } from 'react';
import { LayoutRectangle } from 'react-native';

// use this context o restrict the dropdown to the give bounds
// by default the window viewport will be used.
export const DropdownContext = createContext<
  | {
      boundingRect?: LayoutRectangle;
    }
  | undefined
>(undefined);

export const DropdownProvider: FCC<{
  boundingRect?: LayoutRectangle;
}> = memo(({ boundingRect, children }) => {
  return (
    <DropdownContext.Provider value={{ boundingRect }}>
      {children}
    </DropdownContext.Provider>
  );
});
